import React from 'react';
import { useSelector } from 'react-redux';
import Pagination from '../../components/shared/table/pagination/Pagination';
import {
  nextVehiclesPageAction,
  prevVehiclesPageAction,
  setVehiclesPageSizeAction,
} from '../../redux/actions/vehiclesActions';

const VehiclesPagination = () => {
  const pageable = useSelector((state) => state.vehicles?.pageable);
  return (
    <Pagination
      pageable={pageable}
      onNextPageClickAction={nextVehiclesPageAction}
      onPrevPageClickAction={prevVehiclesPageAction}
      onPageSizeChangeAction={setVehiclesPageSizeAction}
    />
  );
};

export default VehiclesPagination;
